// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__X6EOO","header":"MergedInvoice_header__23pya"};